import { Slider, Stack, styled } from "@mui/material";

export const SliderField = styled(Slider)(({ theme }) =>
    theme.unstable_sx({
        color: theme.palette.primary.main,
        mx: "auto",
        "& .MuiSlider-thumb": {
            height: 48,
            width: 48,
            backgroundColor: theme.palette.common.white,
            border: "2px solid currentColor",
            "&:hover, &.Mui-focusVisible": {
                boxShadow: "inherit",
            },
        },
        "& .MuiSlider-track": {
            height: 8,
            borderRadius: 4,
            ml: 0,
        },
        "& .MuiSlider-rail": {
            height: 8,
            borderRadius: 4,
            width: "100%",
            ml: 0,
        },
    }),
);

export const SliderMinMaxStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: theme.spacing(3),
    }),
);
